<app-breadcrumb [title]="'Crear'" [items]="['Mantenimientos']" [active_item]="'Crear plan de mantenimiento'">
</app-breadcrumb>

<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css">
<div class="row g-4">
  <div class="col-lg-9">
  <div class="card shadow-sm border-0 rounded-4 plan-card">

    <div class="card-header plan-card-header rounded-top-4">
      <div class="d-flex align-items-center gap-3">
        <div class="header-icon">
          <i class="bi bi-tools"></i>
        </div>
        <div>
       <h5 class="mb-0">
            {{ modoEdicion ? 'Editar' : 'Crear' }} plan de mantenimiento
            <span *ngIf="modoEdicion && formNuevo.get('nombre')?.value" class="text-muted fs-6">
                — {{ formNuevo.get('nombre')?.value }}
            </span>
            </h5>
          <small class="header-sub">Define el alcance y los parámetros que aplicarán a este plan</small>
        </div>
      </div>
    </div>

    <form [formGroup]="formNuevo">
      <div class="card-body px-4 py-4">

        <!-- 1. Información General -->
        <div class="section-eyebrow">
          <span class="step-num">1</span>
          <i class="bi bi-info-circle"></i>
          <span>Información general</span>
        </div>

        <div class="row g-4 mb-2">
          <div class="col-md-4">
            <label class="form-label fw-semibold">Nombre del plan</label>
            <div class="input-group input-group-generated">
              <span class="input-group-text">
                <i class="bi bi-card-text"></i>
              </span>
              <input type="text" class="form-control" formControlName="nombre"
                     placeholder="Se generará automáticamente" readonly>
              <span class="input-group-text auto-badge" title="Este campo se genera automáticamente">
                <i class="bi bi-magic"></i> Auto
              </span>
            </div>
            <small class="text-secondary">Se construye a partir de la clase, marca y combustible que elijas abajo.</small>
          </div>
        </div>

        <!-- 2. Datos del Vehículo -->
        <div class="section-eyebrow mt-5">
          <span class="step-num">2</span>
          <i class="bi bi-car-front"></i>
          <span>Datos del vehículo</span>
        </div>

        <div class="row g-4 mb-2">
          <div class="col-md-4">
            <label class="form-label fw-semibold">
              Clase de vehículo <span class="text-danger">*</span>
            </label>
            <ng-select #inputClase id="clase" [items]="tiposVehiculo" bindLabel="tipos" bindValue="idTipos"
                       placeholder="Selecciona una opción" formControlName="clase"
                       class="js-example-placeholder-multiple" style="flex-grow: 1" [class.is-invalid]="
                  formNuevo.get('clase')?.invalid &&
                  formNuevo.get('clase')?.touched
                ">
            </ng-select>
            <div class="text-danger mt-1 small" *ngIf="formNuevo.get('clase')?.invalid && formNuevo.get('clase')?.touched">
              Selecciona una clase de vehículo.
            </div>
          </div>

          <div class="col-md-4">
            <label class="form-label fw-semibold">
              Marca <span class="text-danger">*</span>
            </label>
            <ng-select #inputMarca id="marca" [items]="marcasVehiculo" bindLabel="marca" bindValue="id"
                       placeholder="Selecciona una opción" formControlName="marca"
                       class="js-example-placeholder-multiple" style="flex-grow: 1" [class.is-invalid]="
                  formNuevo.get('marca')?.invalid &&
                  formNuevo.get('marca')?.touched
                ">
            </ng-select>
            <div class="text-danger mt-1 small" *ngIf="formNuevo.get('marca')?.invalid && formNuevo.get('marca')?.touched">
              Selecciona una marca.
            </div>
          </div>

          <div class="col-md-4">
            <label class="form-label fw-semibold">
              Tipo de combustible <span class="text-danger">*</span>
            </label>
            <ng-select #inputCombustible id="combustible" [items]="combustibles" bindLabel="nombre" bindValue="id"
                       placeholder="Selecciona una opción" formControlName="combustible"
                       class="js-example-placeholder-multiple" style="flex-grow: 1" [class.is-invalid]="
                  formNuevo.get('combustible')?.invalid &&
                  formNuevo.get('combustible')?.touched
                ">
            </ng-select>
            <div class="text-danger mt-1 small" *ngIf="formNuevo.get('combustible')?.invalid && formNuevo.get('combustible')?.touched">
              Selecciona un tipo de combustible.
            </div>
          </div>
        </div>

        <!-- 3. Parámetros del Plan -->
        <div class="section-eyebrow mt-5">
          <span class="step-num">3</span>
          <i class="bi bi-sliders"></i>
          <span>Parámetros del plan</span>
        </div>

        <div class="row g-4 mb-2">

          <!-- Modelos -->
          <div class="col-md-6">
            <div class="range-card" [class.range-disabled]="formNuevo.get('todosModelos')?.value">

              <div class="d-flex justify-content-between align-items-start mb-3">
                <div class="d-flex gap-2 align-items-start">
                  <div class="range-icon"><i class="bi bi-calendar-range"></i></div>
                  <div>
                    <h6 class="mb-1 fw-bold">Rango de modelos</h6>
                    <small class="text-secondary">Define los años de los vehículos</small>
                  </div>
                </div>

                <div class="form-check form-switch mb-0">
                  <input class="form-check-input" type="checkbox" role="switch"
                         id="todosModelos" formControlName="todosModelos">
                  <label class="form-check-label ms-2" for="todosModelos">Todos</label>
                </div>
              </div>

              <div class="range-status" *ngIf="formNuevo.get('todosModelos')?.value">
                <i class="bi bi-unlock-fill"></i> Sin restricción de año — aplica a todos los modelos
              </div>

              <div class="row g-3" [class.opacity-50]="formNuevo.get('todosModelos')?.value">
                <div class="col-sm-6">
                  <label for="modeloDesdePlan" class="form-label fw-semibold">Desde</label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="bi bi-calendar3"></i></span>
                    <input type="number" id="modeloDesdePlan" class="form-control"
                           placeholder="Ej: 2018" formControlName="modeloDesde">
                  </div>
                </div>

                <div class="col-sm-6">
                  <label for="modeloHastaPlan" class="form-label fw-semibold">Hasta</label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="bi bi-calendar-check"></i></span>
                    <input type="number" id="modeloHastaPlan" class="form-control"
                           placeholder="Ej: 2025" formControlName="modeloHasta">
                  </div>

                  <div class="text-danger mt-1 small"
                       *ngIf="formNuevo.get('modeloHasta')?.hasError('required') && formNuevo.get('modeloHasta')?.touched">
                    <i class="fa fa-exclamation-circle"></i> El modelo final es obligatorio.
                  </div>
                  <div class="text-danger mt-1 small"
                       *ngIf="formNuevo.get('modeloHasta')?.hasError('rangeError') && formNuevo.get('modeloHasta')?.touched">
                    <i class="fa fa-exclamation-circle"></i> El modelo final debe ser mayor o igual al inicial.
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Cilindrajes -->
          <div class="col-md-6">
            <div class="range-card" [class.range-disabled]="formNuevo.get('todosCilindrajes')?.value">

              <div class="d-flex justify-content-between align-items-start mb-3">
                <div class="d-flex gap-2 align-items-start">
                  <div class="range-icon"><i class="bi bi-speedometer2"></i></div>
                  <div>
                    <h6 class="mb-1 fw-bold">Rango de cilindraje</h6>
                    <small class="text-secondary">Define la capacidad del motor</small>
                  </div>
                </div>

                <div class="form-check form-switch mb-0">
                  <input class="form-check-input" type="checkbox" role="switch"
                         id="todosCilindrajes" formControlName="todosCilindrajes">
                  <label class="form-check-label ms-2" for="todosCilindrajes">Todos</label>
                </div>
              </div>

              <div class="range-status" *ngIf="formNuevo.get('todosCilindrajes')?.value">
                <i class="bi bi-unlock-fill"></i> Sin restricción de cilindraje — aplica a todos
              </div>

              <div class="row g-3" [class.opacity-50]="formNuevo.get('todosCilindrajes')?.value">
                <div class="col-sm-6">
                  <label for="cilindrajeDesdePlan" class="form-label fw-semibold">Desde</label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="bi bi-speedometer2"></i></span>
                    <input type="number" id="cilindrajeDesdePlan" class="form-control"
                           placeholder="Ej: 1200" formControlName="cilindrajeDesde">
                    <span class="input-group-text">cc</span>
                  </div>
                </div>

                <div class="col-sm-6">
                  <label for="cilindrajeHastaPlan" class="form-label fw-semibold">Hasta</label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="bi bi-speedometer"></i></span>
                    <input type="number" id="cilindrajeHastaPlan" class="form-control"
                           placeholder="Ej: 3000" formControlName="cilindrajeHasta">
                    <span class="input-group-text">cc</span>
                  </div>

                  <div class="text-danger mt-1 small"
                       *ngIf="formNuevo.get('cilindrajeHasta')?.hasError('required') && formNuevo.get('cilindrajeHasta')?.touched">
                    <i class="bi bi-exclamation-circle"></i> El cilindraje final es obligatorio.
                  </div>
                  <div class="text-danger mt-1 small"
                       *ngIf="formNuevo.get('cilindrajeHasta')?.hasError('rangeError') && formNuevo.get('cilindrajeHasta')?.touched">
                    <i class="bi bi-exclamation-circle"></i> El cilindraje final debe ser mayor o igual al inicial.
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

        <!-- 4. Descripción -->
        <div class="section-eyebrow mt-5">
          <span class="step-num">4</span>
          <i class="bi bi-journal-text"></i>
          <span>Descripción</span>
        </div>

        <div class="row">
          <div class="col-12">
            <textarea id="descripcionPlan" class="form-control" rows="4"
                      placeholder="Ingrese una descripción detallada del plan de mantenimiento..."
                      formControlName="descripcionPlan"></textarea>
          </div>
        </div>

      </div>

      <div class="card-footer plan-card-footer text-end rounded-bottom-4">
        <button class="btn btn-outline-secondary me-2" type="button">
          <i class="bi bi-x-circle"></i> Cancelar
        </button>
        <button class="btn btn-primary" type="button" (click)="guardarPlan()">
          <i class="bi bi-check-circle"></i> {{ modoEdicion ? 'Actualizar' : 'Guardar' }}
        </button>
      </div>
    </form>
  </div>
</div>
    
   <div class="col-lg-3">
  <div class="card shadow-sm border-0 rounded-4 summary-card">

    <div class="card-header bg-white border-0 py-3 d-flex align-items-center justify-content-between">
      <h5 class="mb-0 fw-bold">
        <i class="bi bi-card-checklist text-primary"></i>
        Resumen del plan
      </h5>
      <span class="progress-badge" [class.progress-complete]="porcentajeCompletado === 100">
        {{ porcentajeCompletado }}%
      </span>
    </div>

    <div class="px-3">
      <div class="progress-track">
        <div class="progress-fill" [style.width.%]="porcentajeCompletado"></div>
      </div>
    </div>

    <div class="card-body p-0">
      <div class="summary-list">

        <div class="summary-row">
          <div class="icon bg-primary-subtle text-primary">
            <i class="bi bi-car-front-fill"></i>
          </div>
          <div class="ms-3">
            <small class="d-block text-secondary">Clase de vehículo</small>
            <div class="fw-semibold text-dark" id="rvClase">
              {{ tipoVehiculoSeleccionado || 'Sin definir' }}
            </div>
          </div>
        </div>

        <div class="summary-row border-top">
          <div class="icon bg-secondary-subtle text-secondary">
            <i class="bi bi-award-fill"></i>
          </div>
          <div class="ms-3">
            <small class="d-block text-secondary">Marca de vehículo</small>
            <div class="fw-semibold text-dark" id="rvMarca">
              {{ marcaSeleccionada || 'Sin definir' }}
            </div>
          </div>
        </div>

        <div class="summary-row border-top">
          <div class="icon bg-warning-subtle text-warning">
            <i class="bi bi-fuel-pump-fill"></i>
          </div>
          <div class="ms-3">
            <small class="d-block text-secondary">Combustible del vehículo</small>
            <div class="fw-semibold text-dark" id="rvCombustible">
              {{ combustibleSeleccionado?.nombre || 'Sin definir' }}
            </div>
          </div>
        </div>

        <div class="summary-row border-top">
          <div class="icon bg-success-subtle text-success">
            <i class="bi bi-calendar-range-fill"></i>
          </div>
          <div class="ms-3">
            <small class="d-block text-secondary">Modelos de vehículos</small>

            <div class="fw-semibold text-dark" id="rvModelos"
                 *ngIf="formNuevo.get('todosModelos')?.value || (formNuevo.get('modeloDesde')?.value && formNuevo.get('modeloHasta')?.value)">
              {{ formNuevo.get('todosModelos')?.value
                  ? 'Todos los modelos'
                  : formNuevo.get('modeloDesde')?.value + ' - ' + formNuevo.get('modeloHasta')?.value }}
            </div>
            <span class="undefined-chip"
                  *ngIf="!formNuevo.get('todosModelos')?.value && !(formNuevo.get('modeloDesde')?.value && formNuevo.get('modeloHasta')?.value)">
              <i class="bi bi-exclamation-triangle-fill"></i> Sin definir
            </span>
          </div>
        </div>

        <div class="summary-row border-top">
          <div class="icon bg-info-subtle text-info">
            <i class="bi bi-speedometer2"></i>
          </div>
          <div class="ms-3">
            <small class="d-block text-secondary">Cilindraje de vehículos</small>

            <div class="fw-semibold text-dark" id="rvCilindraje"
                 *ngIf="formNuevo.get('todosCilindrajes')?.value || (formNuevo.get('cilindrajeDesde')?.value && formNuevo.get('cilindrajeHasta')?.value)">
              {{ formNuevo.get('todosCilindrajes')?.value
                  ? 'Todos los cilindrajes'
                  : formNuevo.get('cilindrajeDesde')?.value + ' - ' + formNuevo.get('cilindrajeHasta')?.value + ' cc' }}
            </div>
            <span class="undefined-chip"
                  *ngIf="!formNuevo.get('todosCilindrajes')?.value && !(formNuevo.get('cilindrajeDesde')?.value && formNuevo.get('cilindrajeHasta')?.value)">
              <i class="bi bi-exclamation-triangle-fill"></i> Sin definir
            </span>
          </div>
        </div>

      </div>

      <div class="border-top p-4 summary-footer">
        <div class="fw-semibold mb-2">
          <i class="bi bi-info-circle-fill text-primary"></i>
          Este plan aplicará para
        </div>
        <p class="mb-0 text-secondary" id="rvResumen">
          {{ resumenPlan }}
        </p>
      </div>
    </div>

  </div>
</div>
</div>
 

